import classNames from 'classnames';
import { lazy, useMemo, useCallback, Suspense, cloneElement } from 'react';
import { useEffect, useState } from 'react';
import { useModals } from './use-modals';

export const Modal = ({ modalData, show, onInitialize, close, layer }) => {
	const { styles, closeBtn: contextCloseBtn, closeModal } = useModals();
	const { component: modalComponent, modalProps } = modalData;
	const [stylesFetched, setStylesFetched] = useState(false);
	const [modalFetched, setModalFetched] = useState(false);
	const [modalConfig, setModalConfig] = useState('');
	const [customContainerClass, setCustomContainerClass] = useState('');

	const preloadLazyModal = (importFunct) => {
		return new Promise(resolve => {
			importFunct().then((importedData) => {
				setModalConfig(importedData?.default?.modalConfig ?? {});
				setModalFetched(true);
				resolve(importedData)
			})
		});
	}

	useEffect(() => {
		setCustomContainerClass('');
	}, [])

	useEffect(() => {
		styles().then(() => {
			setStylesFetched(true);
		})
	}, [styles])

	useEffect(() => {
		if(modalFetched && stylesFetched) {
			setTimeout(() => {
				onInitialize();
			}, 20)
		}
	}, [modalFetched, stylesFetched])

	const closeBtn = useMemo(() => cloneElement(contextCloseBtn, {
			className: classNames('modal-closebtn', contextCloseBtn.props.className),
			onClick: () => {
				closeModal(layer);
			}
		}), [contextCloseBtn, layer, closeModal])

	const containerClasses = useMemo(() => {
		let classes = `modal-container layer-${layer}`;
		if(modalConfig?.containerClass) { classes += ' ' + modalConfig.containerClass; }
		if(customContainerClass && customContainerClass.length > 0) { classes += ' ' + customContainerClass; }
		if(show) { classes += ' show'; }

		return classes;
	}, [modalConfig, show, customContainerClass, layer])

	const LazyModal = useMemo(() => {
		return lazy(() => preloadLazyModal(modalComponent))
	}, [modalComponent])

	const overlayClick = useCallback(() => {
		if(!modalConfig.preventClose) {
			close();
		}
	}, [modalConfig]);

	if(stylesFetched && LazyModal) {
		return (
			<div className={containerClasses}>
				<div className="modal-outerwrap">
					<div className="modal-innerwrap">
						<div className="modal-contentwrap">
							<Suspense fallback={<></>}>
								<LazyModal
									{...modalProps}
									layer={layer}
									setContainerClass={setCustomContainerClass}
									close={close}
									closeBtn={closeBtn} />
							</Suspense>
						</div>
					</div>
					<div className="modal-overlay" onClick={overlayClick} />
				</div>
			</div>
		)
	}
	else {
		return null;
	}
}